var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{class:_vm.styles.input,attrs:{"multiple":_vm.multiple},on:{"input":function($event){return _vm.updateValue($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }